export default "/packs/videos/accountGuideMovie-fe4aa38e61c65acf3806d53410fcfa9a.mp4";